export const getSiteId = (url: string = window.location.pathname): string | null => {
  if (!url.includes('sites/')) {
    return null;
  }

  return url.split('sites/')[1].split('/')[0];
};
